<template>
  <b-modal
    ref="addonModal"
    centered
    size="md"
    hide-header-close
    scrollable
    footer-bg-variant=""
    title="Add devices / users for reseller"
    @hidden="
      unselectReseller(),
      clearCurrentAddonData('devices'),
      clearCurrentAddonData('users')
    ">

    <b-form>
      <b-form-group>
        <label for="addDevices-input">Additional Devices</label>
        <b-input-group>
          <b-form-input
            id="addDevices-input"
            name="addDevices-input"
            type="number"
            min="1"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            onwheel="this.blur()"
            v-model.number="addonData.devices"
            :state="getValidationState('devices')"
            placeholder="0"
            class="flex-grow-1" />
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              class="ml-2 btn-icon"
              @click="decreaseValue('devices', 1000)">
              <i class="fa fa-minus fa-sm"></i>
            </b-button>
            <b-button
              variant="outline-primary"
              class="ml-2 btn-icon"
              @click="increaseValue('devices', 1000)">
              <i class="fa fa-plus fa-sm"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback
          v-for="(error, index) in addonError('devices')"
          :key="`${error.field}-${index}`">
          {{ error.message }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group>
        <label for="addUsers-input">Additional Users</label>
        <b-input-group>
          <b-form-input
            id="addUsers-input"
            name="addUsers-input"
            type="number"
            min="1"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            onwheel="this.blur()"
            v-model.number="addonData.users"
            :state="getValidationState('users')"
            placeholder="0"
            class="flex-grow-1" />
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              class="ml-2 btn-icon"
              @click="decreaseValue('users', 1000)">
              <i class="fa fa-minus fa-sm"></i>
            </b-button>
            <b-button
              variant="outline-primary"
              class="ml-2 btn-icon"
              @click="increaseValue('users', 1000)">
              <i class="fa fa-plus fa-sm"></i>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback
          v-for="(error, index) in addonError('users')"
          :key="`${error.field}-${index}`">
          {{ error.message }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>

    <reseller-details-plate />

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          v-b-tooltip.hover.right
          id="cancelModal"
          variant="outline-secondary"
          size="md"
          @click="hideModal('addonModal')">
          Close
        </b-button>
        <b-button
          variant="primary"
          v-wave
          size="md"
          class="ml-auto"
          :disabled="resellersResponses('setResellerAddon')"
          @click="setResellerAddon">
          Submit
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  // actions
  GET_RESELLER,
  SET_RESELLER_ADDON,

  // mutations
  SELECT_RESELLER,
  UNSELECT_RESELLER,
} from '@/core/services/store/resellers.module'
import { showModal, hideModal } from '@/core/utils'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import ResellerDetailsPlate from './ResellerDetailsPlate.vue'

export default {
  name: 'ModalAddon',
  components: {
    ResellerDetailsPlate,
  },
  data() {
    return {
      addonData: {
        users: undefined,
        devices: undefined,
      },

      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'selectedReseller',
      'selectedResellerId',
      'resellerStatusBadge',
      'resellersResponses',
      'addonErrors',
      'addonError',
    ])
  },
  mounted() {
    eventBus.$on('openModal', type => {
      this.showModal(type)
      this.applyCurrentAddonData('users')
      this.applyCurrentAddonData('devices')
    })
  },
  destroyed() {
    eventBus.$off('openModal')

    this.unselectReseller()
    this.clearCurrentAddonData('users')
    this.clearCurrentAddonData('devices')
  },
  methods: {
    setResellerAddon() {
      this.$store
        .dispatch(SET_RESELLER_ADDON, {
          id: this.selectedReseller.id,
          addon: {
            devices_add: this.addonData.devices || 0,
            users_add: this.addonData.users || 0,
          }
        })
        .then(() => {
          this.$store
            .dispatch(GET_RESELLER, { id: this.selectedReseller.id })
            .then(data => {
              this.selectReseller(data)
            })
        })
    },

    applyCurrentAddonData(type) {
      const curr = this.selectedReseller[type].additional
      this.addonData[type] = curr && curr > 0 ? curr : 0
    },

    clearCurrentAddonData(type) {
      this.addonData[type] = undefined
    },

    selectReseller(reseller) {
      this.$store.commit(SELECT_RESELLER, reseller)
    },

    unselectReseller() {
      this.$store.commit(UNSELECT_RESELLER)
    },

    decreaseValue(type, value) {
      if (!this.addonData[type]) {
        return
      }
      const expectedDecrease = this.addonData[type] - value
      if (expectedDecrease > 0) {
        this.addonData[type] = expectedDecrease
      } else {
        this.addonData[type] = 0
      }
    },

    increaseValue(type, value) {
      if (!this.addonData[type]) {
        this.addonData[type] = 0
      }
      this.addonData[type] = this.addonData[type] + value
    },

    getValidationState(field) {
      return this.addonErrors.some(err => err.field == field) ? false : null
    },
  }
}
</script>
